export default {
    explainerText: {
        marginTop: 80,
        marginBottom: 80
    },
    subExplanation: {
        color: 'rgba(26, 26, 26, 0.701961)',
        fontSize: '1.1em',
        lineHeight: '28.8px'
    }    
}


// WEBPACK FOOTER //
// ./src/components/MainText/MainTextStyle.js